import { Routes, Route, Navigate } from 'react-router-dom'
import ErrorBoundary from './components/ErrorBoundary'
import Layout from '@layouts/Layout'
import DashboardPage from '@pages/DashboardPage'
import MerchantsPage from '@pages/MerchantsPage'
import MerchantUsersPage from '@pages/MerchantUsersPage'
import MesUtilisateursPage from '@pages/MesUtilisateursPage'
import ProductsPage from '@pages/ProductsPage'
import OffersPage from '@pages/OffersPage'
import ReservationsPage from '@pages/ReservationsPage'
import ReservationDetails from '@components/reservation/ReservationDetails'
import UsersPage from '@pages/UsersPage'
import StatisticsPage from '@pages/StatisticsPage'
import CategoriesPage from '@pages/CategoriesPage'
import CategoryDetails from '@components/category/CategoryDetails'
import BasketsPage from '@pages/BasketsPage'
import CartsPage from '@pages/CartsPage'
import CartDetailPage from '@components/cart/CartDetailPage'
import AddressesPage from '@pages/AddressesPage'
import FavoritesPage from '@pages/FavoritesPage'
import NotificationsPage from '@pages/NotificationsPage'
import PaymentsPage from '@pages/PaymentsPage'
import ReviewsPage from '@pages/ReviewsPage'
import ReviewPhotoModeration from '@pages/ReviewPhotoModeration'
import LoyaltyPage from '@pages/LoyaltyPage'
import ReferralPage from '@pages/ReferralPage'
import NotFoundPage from '@pages/NotFoundPage'
import LoginPage from '@pages/LoginPage'
import OrganizationsPage from '@pages/OrganizationsPage'
import OrganizationForm from '@components/organization/OrganizationForm'
import OrganizationDetails from '@components/organization/OrganizationDetails'
import OrganizationHierarchy from '@components/organization/OrganizationHierarchy'
import MerchantForm from '@components/merchant/MerchantForm'
import MerchantDetails from '@components/merchant/MerchantDetails'
import UserForm from '@components/user/UserForm'
import UserDetails from '@components/user/UserDetails'
import ProductForm from '@components/product/ProductForm'
import ProductDetails from '@components/product/ProductDetails'
import OfferForm from '@components/offer/OfferForm'
import OfferDetails from '@components/offer/OfferDetails'
import CategoryForm from '@components/category/CategoryForm'
import CountriesPage from '@pages/CountriesPage'
import SettingsPage from '@pages/SettingsPage'
import ProtectedRoute from '@components/ProtectedRoute'
import CountryForm from '@components/country/CountryForm'
import CountryDetails from '@components/country/CountryDetails'
import CurrenciesPage from '@pages/CurrenciesPage'
import RegionsPage from '@pages/RegionsPage'
import TaxRatesPage from '@pages/TaxRatesPage'
import TaxRateForm from '@components/tax/TaxRateForm'
import TaxRateDetails from '@components/tax/TaxRateDetails'
import CurrencyForm from '@components/currency/CurrencyForm'
import CurrencyDetails from '@components/currency/CurrencyDetails'
import RegionForm from '@components/region/RegionForm'
import RegionDetails from '@components/region/RegionDetails'
import GeneralSettingsPage from '@pages/GeneralSettingsPage'
import DietaryTagsPage from '@pages/DietaryTagsPage'
import ScheduledOrdersPage from '@pages/ScheduledOrdersPage'
import MerchantTimeSlotsPage from '@pages/MerchantTimeSlotsPage'
import MessageriePage from '@pages/MessageriePage'
import CancellationPolicyPage from '@pages/CancellationPolicyPage'
import SurpriseBagAnalytics from '@pages/SurpriseBagAnalytics'
import GamificationPage from '@pages/GamificationPage'
import WalletManagementPage from '@pages/WalletManagementPage'
import SubscriptionManagementPage from '@pages/SubscriptionManagementPage'
import DisputeManagementPage from '@pages/DisputeManagementPage'
import QrScannerPage from '@pages/QrScannerPage'
function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 dark:text-gray-100">
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* Protected routes - All authenticated users */}
        <Route element={<ProtectedRoute requireAuth={true} />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            
            {/* Product Routes - Accessible to admin and merchant */}
            <Route path="products">
              <Route index element={<ProductsPage />} />
              <Route path="new" element={<ProductForm />} />
              <Route path=":id" element={<ProductDetails />} />
              <Route path=":id/edit" element={<ProductForm />} />
            </Route>
            
            {/* Offer Routes - Accessible to admin and merchant */}
            <Route path="offers">
              <Route index element={<OffersPage />} />
              <Route path="new" element={<OfferForm />} />
              <Route path=":id" element={<OfferDetails />} />
              <Route path=":id/edit" element={<OfferForm />} />
              <Route path="surprise-bag-analytics" element={<SurpriseBagAnalytics />} />
            </Route>
            
            {/* Reservation Routes - Accessible to admin and merchant */}
            <Route path="reservations">
              <Route index element={<ReservationsPage />} />
              <Route path=":id" element={<ReservationDetails />} />
            </Route>

            {/* Messagerie Route - Accessible to admin and merchant */}
            <Route path="messagerie" element={<MessageriePage />} />

            {/* QR Scanner Route - Accessible to admin and merchant */}
            <Route path="qr-scanner" element={<QrScannerPage />} />

            {/* Scheduled Orders Route - Accessible to admin and merchant */}
            <Route path="scheduled-orders" element={<ScheduledOrdersPage />} />
            
            {/* Mes Utilisateurs Route - Accessible to admin and merchant */}
            <Route path="mes-utilisateurs" element={<MesUtilisateursPage />} />
            
            {/* Admin-only routes - Protected by role check in components */}
            {/* Merchant Routes - Admin only */}
            <Route path="merchants">
              <Route index element={<MerchantsPage />} />
              <Route path="new" element={<MerchantForm />} />
              <Route path=":id" element={<MerchantDetails />} />
              <Route path=":id/edit" element={<MerchantForm />} />
            </Route>
            
            {/* Organization Routes - Admin only */}
            <Route path="organizations">
              <Route index element={<OrganizationsPage />} />
              <Route path="new" element={<OrganizationForm />} />
              <Route path=":id" element={<OrganizationDetails />} />
              <Route path=":id/edit" element={<OrganizationForm />} />
              <Route path=":id/hierarchy" element={<OrganizationHierarchy />} />
            </Route>
            
            {/* Merchant Users Routes - Admin only */}
            <Route path="merchant-users">
              <Route index element={<MerchantUsersPage />} />
            </Route>
            
            {/* User Routes - Admin only */}
            <Route path="users">
              <Route index element={<UsersPage />} />
              <Route path="new" element={<UserForm />} />
              <Route path=":id" element={<UserDetails />} />
              <Route path=":id/edit" element={<UserForm />} />
            </Route>
            
            {/* Category Routes - Admin only */}
            <Route path="categories">
              <Route index element={<CategoriesPage />} />
              <Route path="new" element={<CategoryForm />} />
              <Route path=":id" element={<CategoryDetails />} />
              <Route path=":id/edit" element={<CategoryForm />} />
            </Route>
            
            {/* Basket Routes - Admin only */}
            <Route path="baskets">
              <Route index element={<BasketsPage />} />
            </Route>
            
            {/* Cart Routes - Admin only */}
            <Route path="carts">
              <Route index element={<CartsPage />} />
              <Route path=":sessionId" element={<CartDetailPage />} />
            </Route>
            
            {/* Address Routes - Admin only */}
            <Route path="addresses">
              <Route index element={<AddressesPage />} />
            </Route>
            
            {/* Favorite Routes - Admin only */}
            <Route path="favorites">
              <Route index element={<FavoritesPage />} />
            </Route>
            
            {/* Notification Routes - Admin only */}
            <Route path="notifications">
              <Route index element={<NotificationsPage />} />
            </Route>
            
            {/* Payment Routes - Admin only */}
            <Route path="payments">
              <Route index element={<PaymentsPage />} />
            </Route>
            
            {/* Review Routes - Admin only */}
            <Route path="reviews">
              <Route index element={<ReviewsPage />} />
              <Route path="photos" element={<ReviewPhotoModeration />} />
            </Route>

            {/* Loyalty Routes - Admin only */}
            <Route path="loyalty" element={<LoyaltyPage />} />

            {/* Referral Routes - Admin only */}
            <Route path="referral" element={<ReferralPage />} />

            {/* Gamification Routes - Admin only */}
            <Route path="gamification" element={<GamificationPage />} />

            {/* Wallet Management Routes - Admin only */}
            <Route path="wallet-management" element={<WalletManagementPage />} />

            {/* Subscription Management Routes - Admin only */}
            <Route path="subscriptions" element={<SubscriptionManagementPage />} />

            {/* Dispute Management Routes - Admin only */}
            <Route path="disputes" element={<DisputeManagementPage />} />
            
            {/* Country Routes - Admin only */}
            <Route path="countries">
              <Route index element={<CountriesPage />} />
              <Route path="new" element={<CountryForm />} />
              <Route path=":id" element={<CountryDetails />} />
              <Route path=":id/edit" element={<CountryForm />} />
            </Route>
            
            {/* Currency Routes - Admin only */}
            <Route path="currencies">
              <Route index element={<CurrenciesPage />} />
              <Route path="new" element={<CurrencyForm />} />
              <Route path=":id" element={<CurrencyDetails />} />
              <Route path=":id/edit" element={<CurrencyForm />} />
            </Route>
            
            {/* Region Routes - Admin only */}
            <Route path="regions">
              <Route index element={<RegionsPage />} />
              <Route path="new" element={<RegionForm />} />
              <Route path=":id" element={<RegionDetails />} />
              <Route path=":id/edit" element={<RegionForm />} />
            </Route>
            
            {/* Tax Rate Routes - Admin only */}
            <Route path="tax-rates">
              <Route index element={<TaxRatesPage />} />
              <Route path="new" element={<TaxRateForm />} />
              <Route path=":id" element={<TaxRateDetails />} />
              <Route path=":id/edit" element={<TaxRateForm />} />
            </Route>
            
            {/* Settings Routes - Admin only */}
            <Route path="settings">
              <Route index element={<SettingsPage />} />
              <Route path="general" element={<GeneralSettingsPage />} />
              <Route path="dietary-tags" element={<DietaryTagsPage />} />
              <Route path="time-slots" element={<MerchantTimeSlotsPage />} />
            </Route>

            {/* Cancellation Policy Route - Admin only */}
            <Route path="cancellation-policy" element={<CancellationPolicyPage />} />
            
            <Route path="statistics" element={<StatisticsPage />} />
            
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Route>
        
        {/* Redirect root to login if not authenticated */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </ErrorBoundary>
  )
}

export default App
